/**
 * useHasOpenOverlay — Detecta globalmente se há um overlay modal aberto
 * (Sheet, Dialog, AlertDialog, Drawer do Radix/shadcn).
 *
 * O Radix Dialog aplica o atributo `data-scroll-locked` no `<body>` enquanto
 * existe pelo menos um overlay modal montado. Observamos esse atributo via
 * MutationObserver — assim cobrimos todos os modais do app sem instrumentar
 * cada componente individualmente.
 *
 * Uso típico: ocultar widgets fixos (ex.: bolha de suporte) que ficariam
 * por cima dos controles do Sheet/Dialog.
 *
 * @version 1.0.0 - 2026-06-05
 */
import { useEffect, useState } from 'react';

export function useHasOpenOverlay(): boolean {
  const [hasOverlay, setHasOverlay] = useState<boolean>(false);

  useEffect(() => {
    if (typeof document === 'undefined') return;

    const body = document.body;

    // Sincroniza estado a partir do atributo atual do body.
    const sync = () => {
      setHasOverlay(body.hasAttribute('data-scroll-locked'));
    };

    sync();

    // Observa apenas mudanças no atributo `data-scroll-locked` do body.
    const observer = new MutationObserver(sync);
    observer.observe(body, {
      attributes: true,
      attributeFilter: ['data-scroll-locked'],
    });

    return () => observer.disconnect();
  }, []);

  return hasOverlay;
}
